import type { IAnalyticsRepository } from '@src/domain/analytics/repository/analytics_repository';
import { PageView } from '@src/domain/analytics/value_objects/page_view';

/**
 * Track Page View Use Case
 * Handles tracking of page views in the application
 */
export class TrackPageViewUseCase {
    constructor(private readonly analyticsRepository: IAnalyticsRepository) { }

    async execute(params: {
        path: string;
        title: string;
        location?: string;
        metadata?: Record<string, any>;
    }): Promise<void> {
        const pageView = PageView.create({
            path: params.path,
            title: params.title,
            location: params.location,
            metadata: params.metadata,
        });

        await this.analyticsRepository.trackPageView(pageView);
    }
}
